module.exports = __webpack_public_path__ + "0089b72ab68b31fb09ce1f93b50d1c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_person_unactivated.png
// module id = 12
// module chunks = 0 1 2 3 4